var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "social-image-slider" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Deletion",
            "ok-title": "Yes, Delete"
          },
          on: { ok: _vm.onConfirmRemoveImage },
          model: {
            value: _vm.showRemoveImage,
            callback: function($$v) {
              _vm.showRemoveImage = $$v
            },
            expression: "showRemoveImage"
          }
        },
        [_c("p", [_vm._v("Are you sure you want to delete this image?")])]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "lg", "modal-class": "image-slider-popup-modal" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var ok = ref.ok
                var cancel = ref.cancel
                var hide = ref.hide
                return [_c("span")]
              }
            }
          ]),
          model: {
            value: _vm.showImagePopup,
            callback: function($$v) {
              _vm.showImagePopup = $$v
            },
            expression: "showImagePopup"
          }
        },
        [
          _c("img", {
            staticClass: "post-image-popup",
            attrs: {
              src:
                _vm.apiUrl +
                "viewFileSocialMediaPost/" +
                _vm.socialPost.id +
                "/" +
                _vm.modalImageId +
                "/" +
                _vm.token
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "image-thumbnail-popup-modal",
            size: "lg",
            "modal-class": "image-editor-popup-modal"
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var ok = ref.ok
                var cancel = ref.cancel
                var hide = ref.hide
                return [
                  _c("div", { staticClass: "image-alt" }, [
                    _c(
                      "label",
                      { attrs: { for: "image-alt-" + _vm.modalImageId } },
                      [_vm._v("Image Alt Text")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.modalImageAlt,
                          expression: "modalImageAlt"
                        }
                      ],
                      ref: "altTextInput",
                      staticClass: "image-alt-input",
                      class: _vm.altTextClass(_vm.modalImageAlt),
                      attrs: {
                        tabindex: "1",
                        name: "image-alt-" + _vm.modalImageId,
                        type: "text",
                        placeholder: "Enter image alt text",
                        disabled: _vm.altDisabled
                      },
                      domProps: { value: _vm.modalImageAlt },
                      on: {
                        blur: _vm.imageAltTextUpdated,
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.saveAltText.apply(null, arguments)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.modalImageAlt = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn delete-deliverable-btn",
                        attrs: { title: "Delete Image" },
                        on: { click: _vm.deleteImageClicked }
                      },
                      [_c("i", { staticClass: "fas fa-trash-alt" })]
                    )
                  ])
                ]
              }
            }
          ]),
          model: {
            value: _vm.showImageEditorPopup,
            callback: function($$v) {
              _vm.showImageEditorPopup = $$v
            },
            expression: "showImageEditorPopup"
          }
        },
        [
          _c("img", {
            staticClass: "post-image-popup",
            attrs: {
              src:
                _vm.apiUrl +
                "viewFileSocialMediaPost/" +
                _vm.socialPost.id +
                "/" +
                _vm.modalImageId +
                "/" +
                _vm.token
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.socialPost.files.length > 1,
              expression: "socialPost.files.length > 1"
            }
          ],
          staticClass: "swiper",
          attrs: { id: _vm.getSliderId }
        },
        [
          _c(
            "div",
            { staticClass: "swiper-wrapper" },
            _vm._l(_vm.socialPost.files, function(file) {
              return _c("div", { staticClass: "swiper-slide" }, [
                _c("div", { staticClass: "image-wrap" }, [
                  !_vm.isEditor
                    ? _c(
                        "span",
                        {
                          staticClass: "expand-image-icon",
                          attrs: { "data-fileid": file.id },
                          on: { click: _vm.expandImage }
                        },
                        [_c("i", { staticClass: "fas fa-expand-arrows-alt" })]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("img", {
                    attrs: {
                      "data-fileid": file.id,
                      "data-filealt": file.alt_text,
                      src:
                        _vm.apiUrl +
                        "viewFileSocialMediaPost/" +
                        file.social_post_id +
                        "/" +
                        file.id +
                        "/" +
                        _vm.token
                    },
                    on: { click: _vm.editImage }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "alt-text-wrap",
                    class: _vm.altTextClass(file.alt_text)
                  },
                  [
                    _c("span", { staticClass: "alt-text" }, [
                      _vm._v(_vm._s(_vm.imageAltText(file.alt_text)))
                    ]),
                    _vm._v(" "),
                    _vm.location == "summary"
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-text btn-copy",
                            attrs: {
                              id:
                                "copy-img-alt-text-btn-" +
                                file.social_post_id +
                                "-" +
                                file.id,
                              type: "button",
                              "data-dismiss": "modal"
                            },
                            on: {
                              click: function($event) {
                                return _vm.copyFn(file.alt_text, file.id)
                              }
                            }
                          },
                          [_c("i", { class: _vm.getCopyIconClass(file.id) })]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-tooltip",
                      {
                        attrs: {
                          target:
                            "copy-img-alt-text-btn-" +
                            file.social_post_id +
                            "-" +
                            file.id,
                          triggers: "hover",
                          noninteractive: ""
                        }
                      },
                      [_vm._v(_vm._s(_vm.getCopyTooltipText(file.id)))]
                    ),
                    _vm._v(" "),
                    _vm.isEditor
                      ? _c("img", {
                          staticClass: "edit-image-icon",
                          attrs: {
                            "data-fileid": file.id,
                            "data-filealt": file.alt_text,
                            src: "/images/pencil.svg"
                          },
                          on: { click: _vm.editImage }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "swiper-pagination" }),
          _vm._v(" "),
          _c("div", { staticClass: "swiper-button-prev" }),
          _vm._v(" "),
          _c("div", { staticClass: "swiper-button-next" })
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.socialPost.files, function(file) {
        return _vm.socialPost.files.length <= 1
          ? _c("div", { staticClass: "single-image" }, [
              _c("div", { staticClass: "image-wrap" }, [
                !_vm.isEditor
                  ? _c(
                      "span",
                      {
                        staticClass: "expand-image-icon",
                        attrs: { "data-fileid": file.id },
                        on: { click: _vm.expandImage }
                      },
                      [_c("i", { staticClass: "fas fa-expand-arrows-alt" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("img", {
                  attrs: {
                    "data-fileid": file.id,
                    "data-filealt": file.alt_text,
                    src:
                      _vm.apiUrl +
                      "viewFileSocialMediaPost/" +
                      file.social_post_id +
                      "/" +
                      file.id +
                      "/" +
                      _vm.token
                  },
                  on: { click: _vm.editImage }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "alt-text-wrap",
                  class: _vm.altTextClass(file.alt_text)
                },
                [
                  _c("span", { staticClass: "alt-text" }, [
                    _vm._v(_vm._s(_vm.imageAltText(file.alt_text)))
                  ]),
                  _vm._v(" "),
                  _vm.location == "summary"
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-text btn-copy",
                          attrs: {
                            id:
                              "copy-img-alt-text-btn-" +
                              file.social_post_id +
                              "-" +
                              file.id,
                            type: "button",
                            "data-dismiss": "modal"
                          },
                          on: {
                            click: function($event) {
                              return _vm.copyFn(file.alt_text, file.id)
                            }
                          }
                        },
                        [_c("i", { class: _vm.getCopyIconClass(file.id) })]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-tooltip",
                    {
                      attrs: {
                        target:
                          "copy-img-alt-text-btn-" +
                          file.social_post_id +
                          "-" +
                          file.id,
                        triggers: "hover",
                        noninteractive: ""
                      }
                    },
                    [_vm._v(_vm._s(_vm.getCopyTooltipText(file.id)))]
                  ),
                  _vm._v(" "),
                  _vm.isEditor
                    ? _c("img", {
                        staticClass: "edit-image-icon",
                        attrs: {
                          "data-fileid": file.id,
                          "data-filealt": file.alt_text,
                          src: "/images/pencil.svg"
                        },
                        on: { click: _vm.editImage }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }